import styled from "@emotion/styled"
import { TransparentText } from "../styled-components/transparent-text"

export const PortfolioLinks = styled(TransparentText)`
  -webkit-text-stroke-color: #fefefe;
  counter-increment: page-links;
  position: relative;
  text-align: center;
  transition: all 0.8s ease-in-out;
  font-size: 3rem;
  white-space: nowrap;

  @media (min-width: 1024px) {
    font-size: 6rem;
  }

  :before {
    display: block;
    content: "0" counter(page-links);
    position: absolute;
    left: -1.5rem;
    top: 0.5rem;
    color: #383e47;
    font-family: "Montserrat", sans-serif;
    transform: scale(1, 0.9);
    font-weight: 700;
    color: #fefefe;
    font-size: 0.875rem;
    letter-spacing: 0;

    @media (min-width: 1024px) {
      left: -2.5rem;
      font-size: 1rem;
    }
  }

  :after {
    display: block;
    content: "";
    height: 4px;
    width: 0;
    position: absolute;
    left: 0;
    top: 50%;
    background-color: #2497c6;
    transition: all 0.4s ease-in-out;
  }

  :hover {
    -webkit-text-fill-color: #fefefe;

    :after {
      width: 100%;
    }
  }
`

export const PortfolioWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  counter-reset: page-links;

  ${PortfolioLinks} {
    margin: 1rem 0;
  }

  @media (min-width: 1024px) {
    height: 100vh;
  }
`

export const PortfolioWrapperRel = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #1e1e1e;
  /* background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3E%3Cg fill='%23000000' fill-opacity='1'%3E%3Cpath fill-rule='evenodd' d='M0 0h4v4H0V0zm4 4h4v4H4V4z'/%3E%3C/g%3E%3C/svg%3E"); */
  padding-top: 8rem;

  @media (min-width: 1024px) {
    padding-top: 0;
    height: 100vh;
  }

  p {
    margin: 1rem 0;
  }
`

export const Grid = styled.div`
  grid-area: 2 / 1 / 3 / 2;
  --gridgap: 3vw;
  --gridwidth: 100%;
  --gridheight: 100vh;
  display: grid;
  width: var(--gridwidth);
  height: var(--gridheight);
  grid-template-rows: repeat(10, calc(var(--gridheight) / 10 - var(--gridgap)));
  grid-template-columns: repeat(
    10,
    calc(var(--gridwidth) / 10 - var(--gridgap))
  );
  grid-gap: var(--gridgap);
  align-content: center;
  justify-content: center;
  overflow: hidden;

  .grid__item {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: contain;

    @media (min-width: 1024px) {
      object-fit: cover;
    }

    :after {
      content: "";
      background: #1e1e1eb8;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }

    :first-child {
      grid-area: 3 / 1 / 8 / 4;
    }

    :nth-child(2) {
      grid-area: 1 / 2 / 3 / 4;
    }

    :nth-child(3) {
      grid-area: 5 / 4 / 8 / 8;
    }

    :nth-child(4) {
      grid-area: 2 / 7 / 5 / 11;
    }

    :nth-child(5) {
      grid-area: 1 / 4 / 5 / 7;
    }

    :nth-child(6) {
      grid-area: 8 / 5 / 11 / 2;
    }

    :nth-child(7) {
      grid-area: 10 / 9 / 8 / 11;
    }

    :nth-child(8) {
      grid-area: 5 / 8 / 8 / 10;
    }

    :nth-child(9) {
      grid-area: 8 / 5 / 11 / 9;
    }
  }
`
